const typography = document.querySelector('.typography');

// add typography functions
if (typography) {
    import('./components/typography').then((script) => {
        script.typography();
    });
}
